import React from 'react';
import { LoginForm } from '../components/auth/LoginForm/LoginForm';

const LoginPage: React.FC = () => <LoginForm />;

export default LoginPage;
